import type { IconSvgObject } from './types';

const Quran02Icon: IconSvgObject = [
  ["path", { d: "M12 6L10.8 7L9 7L9 8.8L8 10L9 11.2L9 13L10.8 13L12 14L13.2 13H15L15 11.2L16 10L15 8.8L15 7L13.2 7L12 6Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 22H6C4.89543 22 4 21.1046 4 20M4 20C4 18.8954 4.89543 18 6 18H20V2H6C4.89543 2 4 2.89543 4 4V20ZM19.5 18C19.5 18 18.5 18.7628 18.5 20C18.5 21.2372 19.5 22 19.5 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Quran02Icon;
